import { render, staticRenderFns } from "./update_profile.vue?vue&type=template&id=08464f0a&scoped=true"
import script from "./update_profile.vue?vue&type=script&lang=js"
export * from "./update_profile.vue?vue&type=script&lang=js"
import style0 from "./update_profile.vue?vue&type=style&index=0&id=08464f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08464f0a",
  null
  
)

export default component.exports